import React, { useCallback, useEffect, useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components/macro'

const Container = styled.div`
  position: absolute;
  top: ${props => props.y};
  left: ${props => props.x};
  width: ${props => props.w};
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  overflow: hidden;
  background: ${props => props.theme.colors[props.color] || props.color || 'none'};
  visibility: ${props => props.visibility || 'visible'}
`

function convertRemToPixels(rem) {  
  // Stolen from https://stackoverflow.com/questions/36532307/rem-px-in-javascript  
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
}

function computeWidthString(value) {
  // Get exact pixel number from stings like "20px" or "20rem"

  // eslint-disable-next-line no-unused-vars
  const [full, num, unit] = String(value).match(/(\d+)([^\d]*)/)

  switch (unit) {
    case 'px': return Number(num)
    case '': return Number(num)
    case 'rem': return convertRemToPixels(Number(num))
    default: throw new Error(`Don't know how to convert ${unit}`)
  }
}

const Hovercard = props => {
  const { dockBelow, dockRight, width, offsetY, color, onClickAway } = props

  const [fullWidth, setFullWidth] = useState()

  const containerRef = useRef()

  const handleRootClick = useCallback(event => {
    if (!dockBelow || dockBelow.contains(event.target)) {
      return
    }

    if (onClickAway) {
      event.preventDefault()
      onClickAway(event.target)
    }
  }, [dockBelow, onClickAway])

  useEffect(() => {
    const root = document.getElementById('root')
    if (!root) {
      return
    }
    root.addEventListener('click', handleRootClick, true)
    return () => {
      root.removeEventListener('click', handleRootClick, true)
    }
  }, [handleRootClick])

  useEffect(() => {
    if (dockBelow && width === 'auto' && containerRef.current) {
      const b = containerRef.current.getBoundingClientRect()
      setFullWidth(b.width)
    }
  }, [width, dockBelow])

  if (!dockBelow) {
    return null
  }

  if (width === 'auto' && !fullWidth) {
    // We need to calculated the fullWidth
    return (
      <Container ref={containerRef} x={0} y={0} w="auto" color={color} visibility="hidden">
        {props.children}
      </Container>
    )
  }
  
  const rect = dockBelow.getBoundingClientRect()

  const x = (fullWidth && dockRight) ? `${(rect.left + rect.width) - fullWidth}px` : (width && dockRight && width !== 'auto') ? `${(rect.left + rect.width) - computeWidthString(width)}px` : `${rect.left}px`
  const y = `${rect.top + rect.height + (offsetY || 0) + window.pageYOffset}px`
  const w = width || `${fullWidth || rect.width}px`

  return createPortal(
    <Container x={x} y={y} w={w} color={color}>
      {props.children}
    </Container>
  , document.getElementById('hovercard'))
}

export default Hovercard